<template>
  <div class="forms-container">
    <div class="col-12 col-sm-12 col-md-5 text-center" style="margin:0 auto;">
      <basic-portlet>
        <div class="logo-container mb-3">
          <img src="/build/media/logo/logo_timbre.png">
        </div>
        <h1 class="mb-3">
          Welcome to Timbre
        </h1>
        <login-form />
        <password-rest-form />
        <forgot-password-form />
        <verify-form />
        <two-factor-form />
      </basic-portlet>
      <div class="text-center">
        <a href="https://status.sharp-stream.com/" target="_blank">Status Page</a><br>
        <a href="https://sharp-stream.com/privacy" target="_blank">Privacy Policy</a><br>
        {{ year() }}&nbsp;&copy;&nbsp;<a href="https://sharp-stream.com" target="_blank" class="kt-link">SharpStream Ltd.</a>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from "VueApp/Auth/LoginForm";
import ForgotPasswordForm from "VueApp/Auth/ForgotPasswordForm";
import PasswordRestForm from "VueApp/Auth/PasswordResetForm";
import VerifyForm from "VueApp/Auth/VerifyForm";
import BasicPortlet from "VueComponents/BasicPortlet";
import AuthFormsMixin from "VueMixins/AuthFormsMixin";
import TwoFactorForm from "VueApp/Auth/TwoFactorForm";

export default {
  components: {
    BasicPortlet,
    LoginForm,
    ForgotPasswordForm,
    PasswordRestForm,
    VerifyForm,
    TwoFactorForm,
  },
  mixins: [AuthFormsMixin],
  data() {
    return {
      reset_token: window.reset_token,
      verify: window.verify,
    };
  },
  mounted() {
    if (this.two_factor_required !== undefined) {
      this.showForm('two_factor_form');
    } else if (this.reset_token !== undefined) {
      this.showForm('password_reset_form');
    } else if (window.set_pasword !== undefined) {
      this.showForm('password_reset_form');
    } else if (this.verify !== undefined) {
      this.showForm('verify_email_form');
    } else {
      this.showForm('login_form');
    }
  },
  methods: {
    year() {
      return moment().format('YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
  .logo-container {
    text-align: center;
    img {
      width:70%;
      margin:0 auto 2rem auto;
      text-align:center;
    }
  }
</style>
